module.exports = {"apiKey":"AIzaSyAHKU7wtA-2S5DAbDqXcGUp_Yy3Qo_MUmM","authDomain":"lookme.vn","databaseURL":"https://lookme-192603.firebaseio.com","projectId":"lookme-192603","storageBucket":"lookme-192603.appspot.com","messagingSenderId":"21833284502","appId":"1:21833284502:web:bd196921a2caa0fb063bb7","measurementId":"G-DF8814S2F2"}


//////////////////
// WEBPACK FOOTER
// ./src/firebase-config-prod.json
// module id = 1217
// module chunks = 0